import { render } from "./DFormsTest.vue?vue&type=template&id=3d3117b2&ts=true"
import script from "./DFormsTest.vue?vue&type=script&lang=ts"
export * from "./DFormsTest.vue?vue&type=script&lang=ts"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\Atlanta-FE-Git-189PRE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__